<template>
    <div>
        <NuxtLinkLocale v-if="props.route" :to="props.route" :class="['relative px-5 py-3 border cta custom_border', { 'cta-zaagl': props.variant === 'zaagl' }]">
            <span>{{ props.title}}</span>
            
            <!-- corners  -->
                <div class="border_corners absolute left-0 top-0  inset-0  z-[100] ">
                <div class="relative size-full border_corners_inner">
                    <!-- left top  -->
                    <span class=" absolute border_corner_left_top left-0 top-0 border-t border-l custom_border size-[15px]"></span>
                    <!-- left bottom  -->
                    <span class=" absolute border_corner_left_bottom left-0 bottom-0 border-b border-l custom_border size-[15px]"></span>
                    <!-- right top  -->
                    <span class=" absolute border_corner_right_top right-0 top-0 border-t border-r custom_border size-[15px]"></span>
                    <!-- right bottom  -->
                    <span class=" absolute border_corner_right_bottom right-0 bottom-0 border-b border-r custom_border size-[15px]"></span>
                </div>
            </div>
        </NuxtLinkLocale>
        <a
            v-else-if="props.href"
            :href="props.href"
            :target="props.target || '_self'"
            :rel="props.rel"
            :class="['relative px-5 py-3 border cta custom_border', { 'cta-zaagl': props.variant === 'zaagl' }]"
        >
            <span>{{ props.title}}</span>
            
            <!-- corners  -->
                <div class="border_corners absolute left-0 top-0  inset-0  z-[100] ">
                <div class="relative size-full border_corners_inner">
                    <!-- left top  -->
                    <span class=" absolute border_corner_left_top left-0 top-0 border-t border-l custom_border size-[15px]"></span>
                    <!-- left bottom  -->
                    <span class=" absolute border_corner_left_bottom left-0 bottom-0 border-b border-l custom_border size-[15px]"></span>
                    <!-- right top  -->
                    <span class=" absolute border_corner_right_top right-0 top-0 border-t border-r custom_border size-[15px]"></span>
                    <!-- right bottom  -->
                    <span class=" absolute border_corner_right_bottom right-0 bottom-0 border-b border-r custom_border size-[15px]"></span>
                </div>
            </div>
        </a>
        <button v-else :type="props.type" :disabled="props.disabled || undefined" :class="['relative px-5 py-3 border cta custom_border', { 'cta-zaagl': props.variant === 'zaagl' }]">
            <span>{{ props.title}}</span>
            
            <!-- corners  -->
                <div class="border_corners absolute left-0 top-0  inset-0  z-[100] ">
                <div class="relative size-full border_corners_inner">
                    <!-- left top  -->
                    <span class=" absolute border_corner_left_top left-0 top-0 border-t border-l custom_border size-[15px]"></span>
                    <!-- left bottom  -->
                    <span class=" absolute border_corner_left_bottom left-0 bottom-0 border-b border-l custom_border size-[15px]"></span>
                    <!-- right top  -->
                    <span class=" absolute border_corner_right_top right-0 top-0 border-t border-r custom_border size-[15px]"></span>
                    <!-- right bottom  -->
                    <span class=" absolute border_corner_right_bottom right-0 bottom-0 border-b border-r custom_border size-[15px]"></span>
                </div>
            </div>
        </button>
    </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
    },
    route: {
        type: String,
    },
    href: {
        type: String,
    },
    target: {
        type: String,
    },
    rel: {
        type: String,
        default: undefined,
    },
    variant: {
        type: String,
        default: "default",
    },
    // Only for the <button> variant (no route/href), e.g. a form's submit button.
    type: {
        type: String,
        default: undefined,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

</script>
<style scoped>

.cta {
    position: relative;
    flex: 0 0 auto;
    display: flex;
    height: 48px;
    outline: none;
    user-select: none;
    cursor: pointer;
    color: rgb(var(--primary-rgb));
    min-width: 0px;
    transition: background-color 0.25s cubic-bezier(0.25, 0.1, 0.25, 1), border-color 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
    border: 1px solid rgb(var(--primary-rgb));
}

.cta::after {
    content: "";
    pointer-events: none;
    position: absolute;
    inset: 1px;
    z-index: 1;
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    transition: opacity 0.25s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.cta::after {
    background: linear-gradient(45deg, rgb(var(--primary-rgb) / 0.85), rgba(173, 142, 182, 0.5));
    opacity: 0.2;
}

.cta:hover {
    background-color: rgb(var(--primary-rgb) / 0.12);
    border-color: rgb(var(--primary-rgb) / 0.4);
    text-decoration: none;
}

.cta-zaagl {
    color: var(--color-zaagl-primary);
    border-color: var(--color-zaagl-primary);
}

.cta-zaagl::after {
    background: linear-gradient(
        45deg,
        color-mix(in srgb, var(--color-zaagl-primary) 82%, white),
        color-mix(in srgb, var(--color-zaagl-primary-light) 70%, white)
    );
}

.cta-zaagl:hover {
    background-color: color-mix(in srgb, var(--color-zaagl-primary-light) 28%, transparent);
    border-color: color-mix(in srgb, var(--color-zaagl-primary) 70%, white);
}

.cta-zaagl .border_corners_inner > span {
    border-color: var(--color-zaagl-primary) !important;
}


.border_corners_inner > span {
    opacity: 0;
    transition: .15s ease-in-out;
}

.border_corners:hover .border_corners_inner .border_corner_right_bottom{
    right: -7.5px;
    bottom: -7.5px;
    opacity: 1;
}
.border_corners:hover .border_corners_inner .border_corner_left_top{
    left: -7.5px;
    top: -7.5px;
    opacity: 1;
}
.border_corners:hover .border_corners_inner .border_corner_right_top{
    right: -7.5px;
    top: -7.5px;
    opacity: 1;
}
.border_corners:hover .border_corners_inner .border_corner_left_bottom{
    left: -7.5px;
    bottom: -7.5px;
    opacity: 1;
}
</style>